import { useEffect, useRef } from "react";
import { TestType } from "../../models/Enums";
import { Chart, registerables } from "chart.js";

interface Props {
  graphDetails: TrendlineGraphDetails;
  setSelectedIndex: Function;
  setIsGraphClicked: Function;
  circleClicked: Function;
}

interface TrendlineGraphDetails {
  assessmentType: TestType;
  graphSvg: React.ReactNode;
  lineGraphValues: any;
  RangeIds: string[];
}

const CustomFloatingBarGraph: React.FC<Props> = ({
  graphDetails,
  setSelectedIndex,
  setIsGraphClicked,
  circleClicked,
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const selectedPointIndexRef = useRef<any>(null);

  let chartLine: any;

  useEffect(() => {
    debugger;
    if (graphDetails?.RangeIds && graphDetails.RangeIds.length !== 0) {
      selectedPointIndexRef.current = graphDetails.RangeIds.length - 1;
    }
    Chart.register(...registerables);
    createLineGraph();
  }, []);

  useEffect(() => {
    debugger;
    const handleCanvasClick = (evt: MouseEvent) => {
      if (!chartLine) return;
    
      console.log("Handle canvas click");
    
      const res = chartLine.getElementsAtEventForMode(
        evt,
        "point",
        { intersect: true },
        true
      );
    
      if (!res.length) {
        // If clicked outside any points, do nothing
        console.log("Clicked outside points, ignoring");
        return;
      }
    
      const clickedIndex = res[0]?.index;
    
      if (clickedIndex === undefined || clickedIndex === selectedPointIndexRef.current) {
        // If the same point is clicked again or invalid index, do nothing
        console.log("Clicked same point or invalid index, ignoring");
        return;
      }
    
      // Update selection and trigger callbacks
      selectedPointIndexRef.current = clickedIndex;
      setSelectedIndex(clickedIndex);
      setIsGraphClicked(true);
      circleClicked(clickedIndex);
    };
    

    const canvas = canvasRef.current;
    if (canvas) {
      canvas.addEventListener("click", handleCanvasClick);
    }

    return () => {
      if (canvas) {
        canvas.removeEventListener("click", handleCanvasClick);
      }
      if (chartLine) {
        chartLine.destroy();
      }
    };
  }, []); // Dependency on chartline if needed

  function getNextMultipleOf45(value: number): number {
    return Math.ceil((value + 20) / 45) * 45;
  }

  function getMaxY(): number {
    // Flatten the 2D array and consider both elements of each pair
    const allValues = graphDetails.lineGraphValues
      .flat() // Flatten to a single array of [x, y] pairs
      .flat(); // Flatten further to get a 1D array of all numbers

    // Find the maximum value
    const maxValue = Math.max(...allValues);

    // Round up to the next multiple of 45
    return getNextMultipleOf45(maxValue);
  }

  const highlightSelectedDate = () => {
    debugger;
    const chart = chartLine;
    const ctx = chart.ctx;
    const xAxis = chart.scales["x"];

    // Clear only the area needed, e.g., below the x-axis for labels
    ctx.clearRect(0, 0, chart.width, chart.height);

    // Redraw the chart
    chart.draw();

    if (
      selectedPointIndexRef?.current !== null &&
      selectedPointIndexRef?.current !== undefined
    ) {
      const index = selectedPointIndexRef.current;

      console.log("Selected index in highlight: ", index);

      // Set shadow and styling for highlighting
      ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
      ctx.shadowBlur = 15;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 2;
      ctx.fillStyle = "#01A7C2";
      ctx.font = "bold 14px";

      // Update label options if available
      const labelItems = xAxis.getLabelItems();
      if (labelItems) {
        try {
          // Reset all label colors
          labelItems.forEach((labelItem: any) => {
            labelItem.options.color = "gray";
          });
          // Set the color for the selected index
          if (labelItems.length > index) {
            labelItems[index].options.color = "black";
          }
        } catch (ex: any) {
          console.log(ex);
        }
      }

      // Highlight the selected date
      const rangeId = graphDetails.RangeIds[index];
      const textWidth = ctx.measureText(rangeId).width;
      const xPos = xAxis.getPixelForValue(index);

      ctx.fillText(rangeId, xPos - textWidth / 2, xAxis.bottom + 20);
      ctx.restore();
      chart.draw();

      highlightBars();
    }
  };

  const highlightBars = () => {
    debugger;
    const chart = chartLine;
    const ctx = chart.ctx;
    const xAxis = chart.scales["x"];

    // Clear only the area needed, e.g., below the x-axis for labels
    ctx.clearRect(0, 0, chart.width, chart.height);

    // Redraw the chart
    chart.draw();

    if (
      selectedPointIndexRef?.current !== null &&
      selectedPointIndexRef?.current !== undefined
    ) {
      const index = selectedPointIndexRef.current;
      const colors = ["#0E76BD", "#9F3412", "#8D33FF"]; // Add as many colors as needed
      const padding = 4; // White padding

      // Highlight the bars with different colors
      chart.data.datasets.forEach((dataset: any, datasetIndex: any) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        const bar = meta.data[index]; // Get the bar at the selected index

        if (bar) {
          ctx.save();

          // Calculate bar dimensions with padding
          const x = bar.x - bar.width / 2 + padding;
          const y = bar.y + padding;
          const width = bar.width - padding * 2;
          const height = bar.base - bar.y - padding * 2;

          // Function to draw rounded rectangle
          const drawRoundedRect = (
            ctx: any,
            x: number,
            y: number,
            width: number,
            height: number,
            radius: number
          ) => {
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(
              x + width,
              y + height,
              x + width - radius,
              y + height
            );
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
          };

          // Clear the area of the bar
          ctx.clearRect(
            bar.x - bar.width / 2,
            bar.y,
            bar.width,
            bar.base - bar.y
          );

          // Fill the bar (shrink it to create space for the border)
          ctx.fillStyle = colors[datasetIndex % colors.length];
          drawRoundedRect(ctx, x, y, width, height, 4); // 4px radius
          ctx.fill();

          // Draw the border around the full bar dimensions with an offset
          ctx.lineWidth = 2; // Border thickness
          ctx.lineJoin = "round"; // Create a rounded corner effect
          ctx.lineCap = "round"; // Create a rounded corner effect

          if (datasetIndex === 0) {
            ctx.strokeStyle = "#0E76BD";
          } else if (datasetIndex === 1) {
            ctx.strokeStyle = "#9F3412";
          }

          drawRoundedRect(
            ctx,
            bar.x - bar.width / 2 - 1, // Offset the left edge by 1 pixel
            bar.y - 1, // Offset the top edge by 1 pixel
            bar.width + 2, // Increase the width by 2 pixels
            bar.base - bar.y + 2, // Increase the height by 2 pixels
            4 // 4px radius
          );

          ctx.stroke();
          ctx.save();
        }
      });

      ctx.restore(); // Restore to the original state
    }
  };

  const createLineGraph = () => {
    // Destroy the existing chart before rendering a new one
    if (chartLine) {
      chartLine.destroy();
    }

    console.log("lineGraphValues: ", graphDetails.lineGraphValues);
    const canvas = canvasRef.current;

    if (canvasRef && canvas) {
      const ctx = canvas.getContext("2d");

      if (ctx) {
        const data = {
          labels: graphDetails.RangeIds,
          datasets: [
            {
              label: "Left Arm",
              data: graphDetails.lineGraphValues[0],
              backgroundColor: "#0E76BD",
              borderRadius: 4,
            },
            {
              label: "Right Arm",
              data: graphDetails.lineGraphValues[1],
              backgroundColor: "#9F3412",
              borderRadius: 4,
            },
          ],
        };

        chartLine = new Chart(ctx, {
          type: "bar",
          data: data,
          options: {
            maintainAspectRatio: false,
            responsive: false,
            scales: {
              x: {
                grid: { display: false },
                ticks: {
                  autoSkip: false, // Ensure all labels are displayed
                  stepSize: 1,
                },
              },
              y: {
                ticks: {
                  stepSize: 45,
                },
                max: getMaxY(),
              },
            },
            animation: {
              onComplete: (chart: any) => {
                if (chart) {
                  debugger;
                  console.log(
                    "Selected point: ",
                    selectedPointIndexRef?.current
                  );
                  highlightSelectedDate();
                }
              },
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
          },
          plugins: [
            {
              id: "displayValues",
              afterDraw(chart) {
                debugger;
                const {
                  ctx,
                  data,
                  chartArea: { left, right },
                  scales: { x, y },
                } = chart;

                const datasetCount = data.datasets.length;
                const barGroupWidth = (right - left) / x.ticks.length; // Width for all bars in a group
                const barWidth = barGroupWidth / datasetCount; // Individual bar width

                // Loop through datasets and their data points
                data.datasets.forEach((dataset, datasetIndex) => {
                  dataset.data.forEach((dataPoint, index) => {
                    if (Array.isArray(dataPoint)) {
                      let [start, end] = dataPoint;

                      // Swap values if labels are inverted
                      if (start > end) {
                        [start, end] = [end, start];
                      }

                      // Calculate the exact x-position of the bar center
                      const baseX = x.getPixelForValue(index);
                      let xPos =
                        baseX -
                        barGroupWidth / 2 +
                        barWidth * datasetIndex +
                        barWidth / 2;

                      const yStart = y.getPixelForValue(start); // y-axis start position
                      const yEnd = y.getPixelForValue(end); // y-axis end position

                      ctx.save();
                      ctx.font = "600 12px Arial";
                      ctx.textAlign = "center"; // Center the text horizontally

                      let textColor;
                      if (datasetIndex === 0) {
                        xPos += barWidth / 10;
                        textColor = "#0E76BD"; // Blue for left arm
                      } else {
                        xPos -= barWidth / 10;
                        textColor = "#9F3412"; // Brown for right arm
                      }

                      ctx.fillStyle = textColor;

                      // Display start value below the bar (ensure centering)
                      ctx.fillText(start.toString(), xPos, yStart + 15);

                      // Display end value above the bar (ensure centering)
                      ctx.fillText(end.toString(), xPos, yEnd - 6);

                      ctx.restore();
                    } else {
                      console.warn(
                        `Data point at index ${index} is not an array`
                      );
                    }
                  });
                });
              },
            },
            {
              id: "addShadows",
              beforeDatasetsDraw(chart) {
                debugger;
                const { ctx } = chart;
                chart.data.datasets.forEach((dataset, datasetIndex) => {
                  const meta = chart.getDatasetMeta(datasetIndex);

                  meta.data.forEach((element) => {
                    const { x, y } = element.getProps(["x", "y"]);
                    const { width, base } = element.getProps(["width", "base"]);

                    ctx.save();

                    // Shadow properties
                    ctx.shadowColor = "rgba(0, 0, 0, 0.7)";
                    ctx.shadowBlur = 15;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 10;

                    ctx.fillStyle = "rgba(0,0,0,0.5)";

                    // Draw shadow behind the bars
                    ctx.fillRect(x - width / 2, y + 3, width, base - y - 3);

                    ctx.restore();
                  });
                });
              },
            },
          ],
        });
      }
    }
  };

  return (
    <div id="bar-chart-container" className="chart-canvas-wrapper">
      <canvas
        id="bar-graph"
        ref={canvasRef}
        style={{
          width: `${
            graphDetails.RangeIds.length <= 7
              ? 100
              : (graphDetails.RangeIds.length - 7) * 20 + 100
          }%`,
          height: "100%",
        }}
      ></canvas>
    </div>
  );
};

export default CustomFloatingBarGraph;
